import React from "react";
import PropTypes from "prop-types";
import { CloudinaryImage } from "@website-builder/ui/shared/elements";
import { LeadershipWrapper } from "./style";

const LeadershipTeam = (props) => {
	const { heading, leaders } = props;

	return (
		<LeadershipWrapper>
			<div className="leadershipHeading">{heading}</div>
			<div className="leadersBlock">
				{leaders.map((leader, index) => (
					<div key={index} className="leaderDetail">
						<div className="leaderImage">
							<CloudinaryImage
								lazyload
								sizes={{ default: { height: 180 }, "1200px": { height: 180 } }}
								url={leader.image}
							/>
						</div>
						<div className="leaderName">{leader.heading}</div>
						<div className="leaderDesignation">{leader.description}</div>
					</div>
				))}
			</div>
		</LeadershipWrapper>
	);
};

LeadershipTeam.propTypes = {
	heading: PropTypes.string.isRequired,
	leaders: PropTypes.array,
};

LeadershipTeam.defaultProps = {
	heading: "",
	leaders: [],
};

export default LeadershipTeam;
